module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "page content"
  }, [_c('section', {
    staticClass: "container"
  }, [_c('episode-filter'), _vm._v(" "), _c('div', {
    class: !_vm.loading ? '' : 'loading'
  }, [_vm._l((_vm.episodes), function(episode, index) {
    return (_vm.episodes && _vm.episodes.length) ? _c('episode', {
      key: episode.slug,
      attrs: {
        "index": index,
        "episode": episode
      }
    }) : _vm._e()
  }), _vm._v(" "), (!_vm.episodes || !_vm.episodes.length) ? _c('div', [_c('h2', [_vm._v("No Results")]), _vm._v(" "), _c('p', [_vm._v("Please try again")])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('v-waypoint', {
    on: {
      "waypoint-in": _vm.nextPage
    }
  }) : _vm._e()], 2)], 1), _vm._v(" "), (_vm.scrolled) ? _c('button', {
    staticClass: "sttButton button is-primary",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_vm._v("Top")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a00d9f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Episodes.vue
// module id = 785
// module chunks = 1